export default __webpack_public_path__ + "static/media/form-bg.b34af6e3.svg";